import { render, staticRenderFns } from "./accountPanel.vue?vue&type=template&id=23470b88&lang=pug&"
import script from "./accountPanel.vue?vue&type=script&lang=js&"
export * from "./accountPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports